export function Downloads() {
  return (
    <div className="lg:max-w-[20vw]">
      <h2 className="font-semibold">QUICK LINKS</h2>

      <ul className="mt-3 flex flex-col space-y-2 text-sm font-semibold">
        <a
          href="/files/James_Borgars_CV.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            CURRICULUM VITAE
          </li>
        </a>
        <a
          href="/files/James_Borgars_BSc_Dissertation.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            BSC DISSERTATION
          </li>
        </a>
        <a
          href="/files/James_Borgars_MEng_Dissertation.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            MENG DISSERTATION
          </li>
        </a>
        <a href="/files/nds.pdf" target="_blank" rel="noopener noreferrer">
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            NDS EXPLOIT PAPER
          </li>
        </a>
        <a
          href="/files/Borgars_et_al_Camera_Ready.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            BORGARS ET AL (CAMERA READY)
          </li>
        </a>
        <a
          href="/files/Abbas_et_al_Camera_Ready.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <li className="cursor-pointer border-2 border-slate-500 hover:bg-slate-200 hover:text-slate-950 hover:border-slate-200 rounded-3xl px-2 py-2 text-center text-slate-300">
            ABBAS ET AL (CAMERA READY)
          </li>
        </a>
      </ul>
    </div>
  );
}
